import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Divider,
  CircularProgress,
  LinearProgress,
} from '@mui/material';

/**
 * Step 2 – Klaar om te genereren / voortgang tonen.
 */
function StepGenerate({
  videoFile,
  frameIoLink,
  language,
  aspectRatio,
  scriptText,
  sendEmail,
  email,
  uploadToFrameIo,
  selectedFolderPath,
  loading,
  progressMessage,
  progress,
}) {
  return (
    <Box sx={{ mt: 3, textAlign: 'center' }}>
      <Typography variant="h6" gutterBottom>
        🚀 Klaar om te genereren
      </Typography>

      <Card sx={{ maxWidth: 500, mx: 'auto', mt: 3 }}>
        <CardContent>
          <Typography variant="subtitle2" color="textSecondary">Samenvatting</Typography>
          <Divider sx={{ my: 2 }} />

          <Box sx={{ textAlign: 'left' }}>
            <Typography><strong>Video:</strong> {videoFile?.name || frameIoLink || '-'}</Typography>
            <Typography>
              <strong>Taal:</strong>{' '}
              {language === 'auto' ? '🔍 Auto-detect' : language === 'nl' ? '🇳🇱 Nederlands' : '🇬🇧 Engels'}
            </Typography>
            <Typography>
              <strong>Formaat:</strong>{' '}
              {aspectRatio === '16:9' ? '📺 16:9 Landscape' : aspectRatio === '9:16' ? '📱 9:16 Portrait' : '⬜ 1:1 Vierkant'}
            </Typography>
            <Typography>
              <strong>Script:</strong>{' '}
              {scriptText ? `Ja (${scriptText.length} karakters)` : 'Nee'}
            </Typography>
            <Typography><strong>Email:</strong> {sendEmail ? email : 'Nee'}</Typography>
            <Typography>
              <strong>Frame.io:</strong>{' '}
              {uploadToFrameIo
                ? `✅ Upload met ondertitels${selectedFolderPath ? ` → ${selectedFolderPath}` : ' (zelfde map als bron)'}`
                : 'Nee'}
            </Typography>
          </Box>
        </CardContent>
      </Card>

      {loading && (
        <Box sx={{ mt: 4 }}>
          <CircularProgress size={60} />
          <Typography variant="h6" sx={{ mt: 2 }}>{progressMessage}</Typography>
          <LinearProgress variant="determinate" value={progress} sx={{ mt: 2, maxWidth: 400, mx: 'auto' }} />
          <Typography variant="body2" color="textSecondary">{progress}%</Typography>
        </Box>
      )}
    </Box>
  );
}

export default StepGenerate;
